/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ConceptNode } from './conceptNode';


export interface ConceptModel { 
    noticeSubTypeCode?: string;
    sdkVersion?: ConceptModel.SdkVersionEnum;
    root?: ConceptNode;
}
export namespace ConceptModel {
    export type SdkVersionEnum = 'DE_SDK_1_1' | 'DE_SDK_1_2' | 'DE_SDK_2_0' | 'DE_SDK_2_1' | 'EU_SDK_1_10' | 'EU_SDK_1_12' | 'EU_SDK_1_13';
    export const SdkVersionEnum = {
        DeSdk11: 'DE_SDK_1_1' as SdkVersionEnum,
        DeSdk12: 'DE_SDK_1_2' as SdkVersionEnum,
        DeSdk20: 'DE_SDK_2_0' as SdkVersionEnum,
        DeSdk21: 'DE_SDK_2_1' as SdkVersionEnum,
        EuSdk110: 'EU_SDK_1_10' as SdkVersionEnum,
        EuSdk112: 'EU_SDK_1_12' as SdkVersionEnum,
        EuSdk113: 'EU_SDK_1_13' as SdkVersionEnum
    };
}


